import Select from "react-select";
import AssignmentModeToggle from "./AssignmentModeToggle";
import AssignmentTextField from "./AssignmentTextField";
import AssignmentDetailCard from "./AssignmentDetailCard";
import { assignmentSelectComponents, assignmentSelectStyles } from "./assignmentSelectStyles";
import { CUSTOM, FLEET, NONE, PHONE_COUNTRY_CODE } from "./assignmentUtils";

const MODES = [
    { value: FLEET, label: "From our fleet" },
    { value: CUSTOM, label: "Other / partner" },
    { value: NONE, label: "No driver needed" },
];

const formatPhone = (option) =>
    option?.driverPrefix && option?.driverPhone !== "-"
        ? `(${option.driverPrefix}) ${option.driverPhone}`
        : option?.driverPhone || "-";

/**
 * The driver half of one slot. Beyond our own drivers it takes free text for a
 * partner company chauffeur, and "No driver needed" for a trip where the client
 * brings their own — the slot is then settled with nobody named.
 */
const DriverAssignmentField = ({ index, assignment, options, menuPortalTarget, onPatch }) => {
    const mode = assignment.driverAssignmentType;
    const selectedOption = options.find((option) => option.value === assignment.driver) || null;

    return (
        <div className="tw:grid tw:grid-cols-1 tw:gap-4 tw:md:grid-cols-[220px_1fr] tw:md:items-start">
            <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[700] tw:text-[#4E4E4E] tw:md:pt-3">
                Driver
            </div>
            <div className="tw:flex tw:flex-col tw:gap-3">
                <AssignmentModeToggle
                    label={`Driver source for vehicle #${index + 1}`}
                    value={mode}
                    options={MODES}
                    onChange={(next) => onPatch({ driverAssignmentType: next })}
                />

                {mode === NONE ? (
                    <p className="tw:m-0 tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-[#F9F9F9] tw:px-5 tw:py-4 tw:font-hanken-grotesk tw:text-[14px] tw:leading-[20px] tw:text-[#666666]">
                        No driver will be recorded for this vehicle — the client’s own company is providing one.
                    </p>
                ) : mode === CUSTOM ? (
                    <div className="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-2">
                        <AssignmentTextField
                            label="Driver name"
                            placeholder="e.g. Tanaka (partner company)"
                            value={assignment.customDriverName}
                            onChange={(value) => onPatch({ customDriverName: value })}
                        />
                        <AssignmentTextField
                            label="Driver phone number (optional)"
                            placeholder="80-0000-0000"
                            prefix={PHONE_COUNTRY_CODE}
                            value={assignment.customDriverPhone}
                            onChange={(value) => onPatch({ customDriverPhone: value })}
                        />
                    </div>
                ) : (
                    <>
                        <Select
                            placeholder="Select"
                            classNamePrefix={`react-select-assignment-driver-${index}`}
                            styles={assignmentSelectStyles}
                            autoComplete="off"
                            menuPortalTarget={menuPortalTarget}
                            menuPosition="fixed"
                            value={selectedOption}
                            options={options}
                            onChange={(option) => onPatch({ driver: option?.value || "" })}
                            components={assignmentSelectComponents}
                        />

                        {selectedOption ? (
                            <AssignmentDetailCard
                                rows={[
                                    { label: "Driver’s Name", value: selectedOption.driverName },
                                    { label: "Driver’s Phone Number", value: formatPhone(selectedOption) },
                                    { label: "Driver’s Email", value: selectedOption.driverEmail },
                                ]}
                            />
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
};

export default DriverAssignmentField;
